<template>
    <form-container :header="translate('remInboxList.remAccounts')" v-on:save="save" :disabled="loading">
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label>{{translate('incomingDoc.remProvider')}}</label>
                    <!-- <input :value="data.Name" readonly type="text" class="form-control" required /> -->
                    <select name="remProvider" v-model="data.Kind" class="form-control" required>
                        <option value="Tnb">TNB KEP</option>
                        <option value="Turkkep">Türk KEP</option>
                        <option value="Ptt">PTT KEP</option>
                    </select>
                </div>
                <div class="form-group">
                    <label>{{translate('remInboxList.senderREMAdress')}}</label>
                    <input @input="checkInput('RemAddress',$event)" v-model="data.RemAddress" type="email" class="form-control" required />             
                </div>
                <div class="form-group">
                    <label>
                        <input type="checkbox" v-model="data.IsActive" />
                        {{translate('remInboxList.remSendActive')}}
                    </label>
                </div>
            </div>
            <div class="col-6">
                <h5>{{translate('remInboxList.authorizedREMUsers')}}</h5>
                <table class="table table-borderless table-sm">
                    <thead>
                        <tr>
                            <th style="max-width:200px; width:200px;">{{translate('login.user')}}</th>
                            <th>{{translate('remInboxList.remUsername')}}</th>
                            <th style="width:1px;"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="u in data.RemUsers" :key="u.UserId">
                            <td style="max-width:200px; width:200px;">
                                <select-user style="max-width:200px;" :user-list="userList" :requiredAuth="['Rem']" v-model="u.UserId" required></select-user>
                            </td>
                            <td>
                                <input v-if="data.Kind == 'Ptt'" class="form-control" disabled :placeholder="translate('remInboxList.useTcForPTTKEP')" />
                                <input v-else type="text" class="form-control" v-model="u.Username" required>
                            </td>
                            <td class="remove" @click="removeUser(u)" :title="translate('remove')">
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="2" class="text-right">
                                <button type="button" class="btn btn-secondary btn-sm" @click="addUser()">{{translate('remInboxList.addREMProcessAuthor')}}</button>
                            </td>
                            <td></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
        
       

        <template v-slot:footer>
            <div class="row">
                <div class="col">
                    <button type="button" accesskey="g" v-on:click="goBack" class="btn btn-outline-primary">{{translate('goBack')}}</button>
                </div>
                <div class="col text-right">
                    <button accesskey="k" type="submit" class="btn btn-success">{{translate('save')}}</button>
                </div>
            </div>
        </template>
    </form-container>
</template>

<script>
import formMixin from '../formMixin.js';
import formContainer from '../components/FormContainer.vue'
import selectUser from '../components/SelectUser.vue'



export default {
    mixins: [formMixin],
    components: {
        formContainer,
        selectUser
    },
    created(){  
        this.getUsers({predicate: "IsActive= true" })
        .then(x => {
            this.userList = x.Result;
        }).catch(x => {
            console.log("Kullanıcı listesi yüklenemedi:", x);
        });

        this.getData(this.$route.params.id, this.$route.query.kind);
    },
    data() {
        return {
            loading: false,
            modelName: 'RemProvider',
            findRemBySearch :false,
            departments: [],
            data: {},
            userList: null,
        }
    },
    methods: { 
        removeUser(user){
            this.data.RemUsers = this.data.RemUsers.filter(x => x != user);
        },
        addUser(){
            this.data.RemUsers.push({});
        },
        checkInput(value, event) {
        // Check for invalid characters
        if (/[<>]/.test(event.target.value)) {
            alert(this.translate('errors.invalidSymbols'))
            const editedText = ""
            this.$set(this.data, value, editedText)
        } else {
            this.$set(this.data, value, event.target.value)
        }
    },
       
    }
}
</script>